// extracted by mini-css-extract-plugin
module.exports = {"container":"cardComponent_container__141mL","bgImage":"cardComponent_bgImage__oSNmS","image":"cardComponent_image__-tw8Y","icon":"cardComponent_icon__2CyzM","price":"cardComponent_price__38w5F","resume":"cardComponent_resume__1rJJF"};
    if(module.hot) {
      // 1745223376321
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  